let timer;

export default {
    install(options, axios) {

        if (!options) {
            return;
        }

        const seconds     = options.seconds || 300;
        const statusUrl   = options.statusUrl;
        const logoutUrl   = options.url;
        const router      = options.router;
        const checkStatus = options.checkStatus;

        if (!checkStatus) {
            return;
        }

        timer = setInterval(async function () {
            console.log('[status-check]', 'Timer Tick with [', seconds, '] seconds.');
            const response  = await axios.get(statusUrl);
            const data      = response.data;
            const loggedOut = checkStatus(data);
            if (loggedOut === true) {
                router.push(logoutUrl);
                clearInterval(timer);
            }
        }, seconds * 1000);
    }
}

